import React, { useState, useRef, useEffect } from "react";
import {
  Bar,
  Pie,
  Column,
  DualAxes,
  Funnel,
  Heatmap,
  Area,
} from "@ant-design/charts";
import html2canvas from "html2canvas";

import { reportTypeEnum } from "./AppEnums";
import conf from "../reports/custom/chartConf";
import util from "../../utils/functions/custom";

export const GenericChart = ({ data, type, year, onImageSrc, ...rest }) => {
  const [chartInstance, setChartInstance] = useState(null);
  const [isChartReady, setIsChartReady] = useState(false);
  // const [total, setTotal] = useState(0);
  const [doughnutSource, setDoughnutSource] = useState(null);

  useEffect(() => {
    console.log("Use effect" ,chartInstance, rest);
    if (chartInstance) {
      loadChartAsImage();
    }
  }, [chartInstance]);

  const loadChartAsImage = async () => {
    if (!chartInstance) {
      setChartInstance(null);
      observeChartRender(null);
      return;
    }

    onImageSrc(null);

    // This is meant to wait for chart to render completely before capturing image
    await new Promise((resolve) => requestAnimationFrame(resolve));
    await new Promise((resolve) => setTimeout(resolve, 1000));

    const canvasElement = chartInstance.container.querySelector("canvas");
    // Check canvas to avoid displaying empty images
    if (!canvasElement) {
      console.warn("No canvas was found.");
      return;
    }

    // canvasElement.style.imageRendering = "crisp-edges";


    const dataURL = chartInstance.toDataURL("image/png", 1.0);
    if (dataURL) {
      // chartInstance.chart.width = "100%";
      console.log("Image Captured Successfully!");
      onImageSrc(dataURL);
    } else {
      console.error("Failed to capture chart image.");
    }
  };

  const observeChartRender = (chart) => {
    //THis is for detecting chart canvas as soon as it appears
    const observer = new MutationObserver((mutations, obs) => {
      if (chart.container.querySelector("canvas")) {
        console.log("Canvas detected, chart is ready!");

        loadChartAsImage();
        setIsChartReady(true);

        // Stop observing chart changes once detected
        obs.disconnect();
      }
    });

    // observer.observe(chart.container, { childList: true, subtree: true });
  };

  const handleChartReady = async (chart) => {
    setChartInstance(chart);
    observeChartRender(chart);
  };

  const getColor = () => {
    if (type === reportTypeEnum.BAR && rest.color == "demographicPie") {
      return [
        "#3f81af",
        "#37948e",
        "#95ba60",
        "#f9c232",
        "#f36523",
        "#9d405f",
        "#487386",
        "#2b8a84",
        "#8db05c",
      ];
    } else if (type === reportTypeEnum.COLUMN && rest.color === "#2e84bf") {
      return "#2e84bf";
    // } else if (type === reportTypeEnum.GROUPCOL && rest.color == "stemi") {
    //   return ["#16ada0", "#2193ae", "#32669e", "#4945a8"];
    //   "#16ada0", "#239b56", "#32669e", "#4945a8"
     } else if (type === reportTypeEnum.GROUPCOL && rest.color == "Science") {
      return ["#2193ae", "#4945a8", "#34495e", "#16a085"];
    } else if (type === reportTypeEnum.GROUPCOL && rest.color == "OrgsRole") {
      return ["#2193ae", "#3f5e34", "#57345e", "#2ecc71"];
    }
    // else if (type === reportTypeEnum.
    else if (type === reportTypeEnum.GROUPBAR && rest.color == "activities") {
      return [
        "#2e84bf",
        "#37948e",
        "#593055",
        "#e4857e",
        "#67e67d",
        "#ff74c2",
        "#7ca6b4",
        "#4e4e4e",
      ];
    } else if (
      type === reportTypeEnum.GROUPBAR &&
      rest.color == "participation"
    ) {
      return ["#37948e", "#2e84bf"];
    } else if (
      type === reportTypeEnum.GROUPBAR &&
      rest.color == "event_organizer"
    ) {
      return ["#2e84bf", "#37948e", "#4863A0", "#4E5180"];
    } else if (type === reportTypeEnum.COLUMN && rest.color === "ageGroups") {
      return "#37948e";
    } else if (
      type === reportTypeEnum.COLUMN &&
      rest.color === "typeDistribution"
    ) {
      return "#3f81af";
    } else if (
      type === reportTypeEnum.COLUMN &&
      rest.color === "participantType"
    ) {
      return "#3f81af";
    } else if (type == reportTypeEnum.COLUMN && rest.color == "grade") {
      return ["#2193ae", "#32669e"];
    } 
    // else if (type === reportTypeEnum.FUNNEL && rest.color == "raceFunnel") {
    //   return [
    //     "#3f81af",
    //     "#37948e",
    //     "#95ba60",
    //     "#e8d23c",
    //     "#f36523",
    //     "#9d405f",
    //     "#487386",
    //     "#2b8a84",
    //     "#8db05c",
    //   ];
    // } 
    else if (type === reportTypeEnum.COLUMN && rest.color == "During") {
      return "#154360";
    } 
    else if (type === reportTypeEnum.COLUMN && rest.color == "Post") {
      return "#138d75";
    } 
    else if (type === reportTypeEnum.COLUMN && rest.color == "Conceptual") {
      return "#154399";
    } 
    else if (type === reportTypeEnum.GROUPCOL && rest.color == "Science") {
      return ["#2193ae", "#4945a8", "#32669e"];
    } else if (type === reportTypeEnum.GROUPCOL) {
      return ["#2193ae", "#32669e"];
    } else if (
      type === reportTypeEnum.STACKED_AREA &&
      rest.color == "orgObjectives"
    ) {
      return [
        "#3f81af",
        "#37948e",
        "#95ba60",
        "#e8d23c",
        "#f36523",
        "#9d405f",
        "#487386",
        "#2b8a84",
        "#8db05c",
      ];
    } else if (type === reportTypeEnum.HEATMAP && rest.color == "research") {
      return ["#dddddd", "#9ec8e0", "#5fa4cd", "#2e7ab6", "#114d90"];
    }
  };

  //I need to revisit this function once the config file is reusable
  const renderChart = () => {
    //Default config for Pie chart
    if (type === reportTypeEnum.PIE) {
      const configFile = conf.pie;

      let lColor = [
        "#2e84bf",
        "#37948e",
        "#593055",
        "#e4857e",
        "#67e67d",
        "#ff74c2",
        "#7ca6b4",
        "#4e4e4e",
      ];

      if (rest.color === "csGender") {
        lColor = ["#2193AE", "#724DAD", "#4945A8", "#724DAD",'#487386', '#2b8a84', '#8db05c'];
      } else if (rest.color === "scienceFields") {
        lColor = ["#83DFDF", "#2FB8B8", "#2193AE", "#32669E", "#2E4088", "#302E6D", "#25244A"];
      }
      else if (rest.color === "stemiGenderPie") {
        lColor = [
          "#9d405f","#487386", "#8db05c", "#f9c232", "#f36523", "#9d405f", "#487386", "#2b8a84", "#8db05c"
        ];
      }
      else if (rest.color === "stemiSectorPie") {
        lColor = [
          "#3f81af",
        "#37948e",
        "#95ba60",
        "#f9c232",
        "#f36523",
        "#9d405f",
        "#487386",
        "#2b8a84",
        "#8db05c",
        ];
      }
      let newConfig = {
        ...configFile,
        data: data,
        angleField: "value",
        colorField: "type",
        scale: {
          color: {
            range: lColor,
          },
        },
        label: {
          text: ({ percent }) => {
            return `${percent.toFixed(2)}%`;
          },
          style: {
            fontWeight: "bold",
          },
        },
        legend: {
          layout: "horizontal",
          position: "bottom",
        },
        tooltip:false,
        onReady: (chart) => {
          handleChartReady(chart);
        },
      };
      return <Pie {...newConfig} />;
    } else if (type === reportTypeEnum.DOUGHNUT) {
      const configFile = conf.doughnut;
      const tot = data.reduce((sum, item) => sum + item.value, 0);

      let lColor = ["#2FB8B8", "#2193AE", "#32669E", "#4945A8", "#724DAD", "#67e67d", "#ff74c2", "#7ca6b4", "#4e4e4e"];
      if (rest.color === "scienceShops") {
        lColor =["#302E6D", "#724DAD", "#593055", "#e4857e", "#67e67d", "#ff74c2", "#7ca6b4", "#4e4e4e"];
      } else if (rest.color === "ageDougnut") {
        lColor = ["#724dad", "#4945a8", "#32669e", "#2193ae", "#16ada0"];
      } else if (rest.color === "csGender") {
        lColor = ["#724dad", "#4945a8", "#32669e", "#2193ae", "#16ada0"];
      } else if (rest.color === "demographicPie") {
        lColor = [
          "#3f81af",
          "#37948e",
          "#95ba60",
          "#f9c232",
          "#f36523",
          "#9d405f",
          "#487386",
          "#2b8a84",
          "#8db05c",
        ];
      } else if (rest.color === "raceDoughnut") {
        lColor = [ "#302E6D", "#4945A8", "#724DAD", "#2FB8B8", "#2193AE", "#32669E", '#487386', '#2b8a84',  "#487386", "#2b8a84"];
      } else if (rest.color === "qualificationDoughnut") {
        lColor = [
          '#8db05c', "#487386",   '#f7941d', '#f36523', '#9d405f', '#487386', '#2b8a84', "#2b8a84"
        ];
      }
      let newConfig = {
        ...configFile,
        data: data,
        colorField: "type",
        scale: {
          color: {
            range: lColor,
          },
        },
        innerRadius: 0.6,
        label: {
          text: ({ percent }) => {
            return `${percent.toFixed(2)}%`;
          },
          style: {
            fontWeight: "bold",
          },
        },
        annotations: [
          {
            type: "text",
            style: {
              text: `${tot}`,
              x: "50%",
              y: "50%",
              textAlign: "center",
              fontSize: 40,
              fontStyle: "bold",
            },
          },
        ],
        tooltip:false,
        onReady: (chart) => {
          handleChartReady(chart);
        },
      };
      return <Pie {...newConfig} />;
    } else if (type === reportTypeEnum.COLUMN) {
      //Not yet covering stacked/bar charts, however
      //What would be required is simply an update on the config file
      let lColor = ["#2e84bf"];
      const configFile = conf.column;
      if (rest.color === "candidateAge") {
        lColor = ["#2e84bf"];
      }else if (rest.color === "Conceptual") {
        lColor = ["#487386"];
      } else if (rest.color === "ageGroups") {
        lColor = ["#37948e"];
      } else if (rest.color === "During") {
        lColor = ["#2193AE"];
      } else if (rest.color === "Post") {
        lColor = ["#2E4088"];
      } else if (rest.color === "Science") {
        lColor = ["#2193ae"];
      } else if (rest.color === "participantType") {
        lColor = ["#3f81af"];
      } else {
        lColor = ["#2193AE"];
      }

      let newConfig = {
        ...configFile,
        data: data,
        scale: {
          color: {
            range: lColor,
          },
        },
        legend: false,
        xField: "type",
        yField: "value",
        colorField: "",
        label: {
          text: "value",
          position: "inside",
        },
        axis: {
          x: {
            title: rest.xLabel,
            style: {
              titleFill: "black",
            },
            labelFormatter: (text) =>
              text.length > 10 ? text.slice(0, 10) + "..." : text, // Ellipsis for long labels
          },
          y: {
            title: rest.yLabel,
            style: {
              titleFill: "black",
            },
          },
        },
        tooltip:false,
        onReady: (chart) => {
          handleChartReady(chart);
        },
        style: {
          maxWidth: 50,
        },
      };
      return <Column {...newConfig} />;
    } else if (type === reportTypeEnum.GROUPCOL) {
      const configFile = conf.groupCol;
      let xFld = rest.xField;
      let pColor = ["#4945a8", "#724dad"];
      if (rest.color === "Public") {
        pColor = ["#4945a8", "#724dad"];
      } else if (rest.color === "Local") {
        pColor = ["#2193ae", "#32669e"];
      }
      else if (rest.color === "stemi") {
        pColor = ["#16ada0", "#239b56", "#32669e", "#4945a8"];
        xFld = "group";
      }
      else if(rest.color === "stemiProvince"){
        pColor = ["#4945a8", "#724dad", "#2193ae", "#32669e", "#00B3E6", "#E6B333", "#3366E6"];
        xFld = "group";
      }
      else if(rest.color === "stemiGrade")
        {
        pColor = ['#21618c', "#487386", "#8db05c", '#00b8e6', '#387c9f', "#ac85cb", "#3366E6", "#f9c232", '#2b8a84', "#239b56", "#34495e", '#f7941d'];
        xFld = "group";
      }  
      else if (rest.color === "Science") {
        pColor = ["#302E6D", "#4945A8", "#724DAD", "#2FB8B8", "#2193AE", "#32669E", '#487386', '#2b8a84',  "#487386", "#2b8a84"];
      } else if (rest.color === "OrgsRole") {
        pColor = ["#302E6D", "#4945A8", "#724DAD", "#2FB8B8", "#2193AE", "#32669E", "#2E4088"];
      } else if (rest.color === 'orgObjectives') {
        pColor = [ "#4945A8", "#724DAD", "#2FB8B8", "#2193AE", "32669E", "#2E4088"]
      }

      let newConfig = {
        ...configFile,
        data: data,
        scale: {
          color: {
            range: pColor,
          },
        },
        xField: xFld,
        yField: "value",
        stack: true,
        colorField: "type",
        label: {
          text: "value",
          position: "inside",
        },
        legend: {
          color: {
            title: false,
            position: "bottom",
            rowPadding: 5,
          },
        },
        axis: {
          x: {
            title: rest.xLabel,
            style: {
              titleFill: "black",
            },
            labelFormatter: (text) => text.length > 10 ? text.slice(0, 10) + '...' : text, // Ellipsis for long labels
          },
          y: {
            title: rest.yLabel,
            style: {
              titleFill: "black",
            },
          },
        },
        tooltip:false,
        onReady: (chart) => {
          handleChartReady(chart);
        },
        style: {
          maxWidth: 50,
        },
      };
      return <Column {...newConfig} />;
    } else if (type === reportTypeEnum.GROUPBAR) {
      const configFile = conf.grouped;

      let newConfig = {
        ...configFile,
        data: data,
        color: getColor(rest.color),
        xField: rest.xField,
        yField: rest.yField,
        colorField: rest.seriesField,
        label: {
          text: "value",
          position: "inside",
        },
        tooltip:false,
        onReady: (chart) => {
          handleChartReady(chart);
        },
        style: {
          maxWidth: 50,
        },
      };
      return <Column {...newConfig} />;
    } else if (type === reportTypeEnum.DUALAXES) {
      const configFile = conf.dual;
      const output = util.calculateRetention(data);

      let newConfig = {
        ...configFile,

        xField: "year",
        children: [
          {
            data: output?.mainData,
            type: "interval",
            yField: "value",
            stack: true,
            colorField: "type",
            style: { maxWidth: 80 },
            scale: { y: { domainMax: 1200 } },
            interaction: { elementHighlightByColor: { background: true } },
          },
          {
            data: output?.retentionData,
            type: "line",
            yField: "Retention % (end of year)",
            colorField: () => "Retention % (end of year)",
            style: { lineWidth: 2 },
            axis: {
              y: {
                title: "",
                style: {
                  titleFill: "black",
                },
                position: "right",
                labelFormatter: (text) =>
                  text.length > 10 ? text.slice(0, 10) + "..." : text, // Ellipsis for long labels
              },
            },
            interaction: {
              tooltip: {
                crosshairs: false,
                marker: false,
              },
            },
            legend: {
              color: {
                title: false,
                position: "bottom",
                rowPadding: 5,
              },
            },
          },
        ],
        tooltip:false,
        onReady: (chart) => {
          handleChartReady(chart);
        },
      };
      return <DualAxes {...newConfig} />;
    } else if (type === reportTypeEnum.FUNNEL) {
      const configFile = conf.funnel;
      let newConfig = {
        ...configFile,
        data: data,
        xField: "type",
        yField: "value",
        shapeField: "pyramid",
        label: [
          {
            text: (d) => `${d.type}\n${d.value}`,
            position: "inside",
            fontSize: 16,
          },
          {
            render: ($, _, i) => {
              if (i)
                return (
                  <div
                    style={{
                      height: 1,
                      width: 30,
                      background: "#aaa",
                      margin: "0 20",
                    }}
                  ></div>
                );
            },
            position: "top-right",
          },
          {
            text: (d, i, data) => {
              if (i)
                return ((d.value / data[i - 1].value) * 100).toFixed(2) + "%";
            },
            position: "top-right",
            textAlign: "left",
            textBaseline: "middle",
            dx: 40,
          },
        ],
        legend: {
          color: {
            title: false,
            position: "bottom",
            rowPadding: 5,
          },
        },
        onReady: (chart) => {
          handleChartReady(chart);
        },
      };
      return <Funnel {...newConfig} />;
    } else if (type === reportTypeEnum.STACKED_AREA) {
      const configFile = conf.stackedArea;
      let newConfig = {
        ...configFile,
        data: data,
        color: getColor(rest.color),
        xField: rest.xField,
        yField: rest.yField,
        colorField: "type",
        seriesField: "type",
        shapeField: "smooth",
        stack: {
          orderBy: "maxIndex",
          reverse: true,
        },
        label: {
          text: "value",
          position: "inside",
        },
        axis: {
          x: {
            title: rest.xLabel,
            style: {
              titleFill: "black",
            },
            labelFormatter: (text) =>
              text.length > 10 ? text.slice(0, 10) + "..." : text, // Ellipsis for long labels
          },
          y: {
            title: rest.yLabel,
            style: {
              titleFill: "black",
            },
          },
        },
        legend: {
          color: {
            title: false,
            position: "bottom",
          },
        },

        onReady: (chart) => {
          handleChartReady(chart);
        },
      };
      return <Area {...newConfig} />;
    } else if (type === reportTypeEnum.HEATMAP) {

      let lbColor = ["#A4E0F7", "#71AECE", "#3E7CA5", "#0b4a7c"];
      const configFile = conf.heat;
      let newConfig = {
        ...configFile,
        data,
        scale: {
          color: {
            range: lbColor
          },
        },
        xField: rest.xField,
        yField: rest.yField,
        colorField: "value",
        mark: "cell",
        style: { inset: 0.5 },
        label: {
          text: "value",
          position: "inside",
        },
        tooltip:false,
        axis: {
          x: {
            title: rest.xLabel,
            style: {
              titleFill: 'black'
            },
            labelFormatter: (text) => text.length > 10 ? text.slice(0, 10) + '...' : text, // Ellipsis for long labels
          },
          y: {
            title: rest.yLabel,
            style: {
              titleFill: 'black'
            }
          }
        },
        onReady: (chart) => {
          handleChartReady(chart);
        },
      };
      return <Heatmap {...newConfig} />;
    } else if (type === reportTypeEnum.BAR) {

      let lColor = ["#2e84bf", "#37948e", "#593055", "#e4857e", "#67e67d", "#ff74c2", "#7ca6b4", "#4e4e4e"];
      const configFile = conf.bar;

      if (rest.color === "raceBar") {
        lColor = (["#2193AE", "#32669E", "#4945A8", "#724DAD", "#67e67d", "#ff74c2", "#7ca6b4", "#4e4e4e"])
      }
      let newConfig = {
        ...configFile,
        data,
        scale: {
          color: {
            range: lColor,
          },
        },
        xField: 'type',
        yField: 'value',
        colorField: 'type',
        legend: false,
        label: {
          text: 'value',
          style: {
            fontWeight: 'bold',
            marginRight:'10px'
          },
          //  transform: [{ type: 'contrastReverse' }],
           position: 'inside',
        },
        axis: {
          x: {
            title: 'Age range',
            style: {
              titleFill: 'black'
            }
          },
          y: {
            title: "No of Citizen Scientists",
            style: {
              titleFill: 'black'
            }
          }
        },
        tooltip:false,
        onReady: (chart) => {
          handleChartReady(chart);
        },
        style: {
          maxWidth: 50,
        },
      }
      return <Bar {...newConfig} />;
    }
  };

  //The config file should be modifiable based on the report type selected
  //Some work need to be done to make the config reusable

  const config = {
    appendPadding: 10,
    data,
    angleField: "value",
    colorField: "type",
    color: [
      "#3f81af",
      "#37948e",
      "#95ba60",
      "#f9c232",
      "#f36523",
      "#9d405f",
      "#487386",
      "#2b8a84",
      "#8db05c",
    ],
    radius: 1,
    label: {
      type: "inner",
      offset: "-20%",
      content: "{percentage}",
    },
    legend: {
      layout: "horizontal",
      position: "bottom",
    },
    interactions: [
      {
        type: "element-selected",
      },
      {
        type: "element-active",
      },
    ],
    statistic: {
      title: false,
      content: {
        style: {
          whiteSpace: "pre-wrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
    },
    onReady: (chart) => {
      handleChartReady(chart);
    },
  };

  return <div>{renderChart()}</div>;
};

// export default GenericChart;
